<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentTopicArticle.attributes"
          headline="Edit Content Topic Article"
          :errors="errors"
          :portal="portal"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentTopicArticles/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      contentTopicArticle: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-topic-articles/' + this.$route.params.contentTopicArticleId).then(response => {
        this.contentTopicArticle = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-topic-articles/' + this.$route.params.contentTopicArticleId, data)
          .then(() => {
            notify.success('The content topic article was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/topics/' + this.$route.params.contentTopicId + '/edit')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
